/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessGrantedRoles {
    getFixupPrototypeFunction() { return AccessGrantedRoles.fixupPrototype; }

    static newInstance(model: Partial<AccessGrantedRoles>): AccessGrantedRoles {
        let obj = Object.assign(new AccessGrantedRoles(), model);
        AccessGrantedRoles.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessGrantedRoles>): AccessGrantedRoles {
        if (!model) return null;
        return AccessGrantedRoles.newInstance(<AccessGrantedRoles> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessGrantedRoles) {
        if (!obj) return;

        models.AccessGrantedRoles.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessGrantedRoles): boolean {
        Object.setPrototypeOf(obj, AccessGrantedRoles.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID explicitly denied access
     */
    tenant_id: string;

    /**
     * Role IDs under this tenant explicitly denied access
     */
    role_ids: Array<string>;

}
